<template>
  <v-select v-model="model" dense
            v-bind:items="itemList" :item-text="displayMember" :item-value="valueMember"
            :error-messages="validationErrors" :no-data-text="valueItem.noDataText"
            :label="valueItem.label" @change="emitChangeEvent"
            stack-label outlined class="mr-4" attach></v-select>
</template>
<script>
  // WrsViSelect.vue
  export default {
    props: {
      valueItem: {
        type: Object,
        default: function () {
          return {
            label: "",
            isRequired: false,
            requiredError: "",
            error: "",
            hasError: false,
            items: [],
            value: 0
          };
        },
      },
      items: {
        type: Array,
        default() {
          return []
        }
      },
      isExternalItems: {
        type: Boolean,
        default: false
      },
      displayMember: {
        type: String,
        default: "text"
      },
      valueMember: {
        type: String,
        default: "id"
      },
      externalErrorMessage: {
        type: String,
        default: ""
      },
    },
    computed: {
      model: {
        get() {
          return this.valueItem.value;
        },
        set(value) {
          this.valueItem.value = value;
          //this.checkForErrors(this.valueItem);
        }
      },
      itemList: {
        get() {
          if (this.isExternalItems) {
            return this.items;
          }
          else {
            if (this.valueItem.items == null)
              return this.items;
            else
              return this.valueItem.items;
          }
        }
      },
      validationErrors() {
        const errors = [];

        this.checkForErrors(this.valueItem, this.externalErrorMessage);

        if (this.valueItem.hasError) errors.push(this.valueItem.error);
        return errors;
      },
    },
    methods: {
      checkForErrors: (vi, eem) => {
        if (eem) {
          if (eem != "") {
            vi.hasError = true;
            vi.error = eem;
            return;
          }
        }

        if (vi.isRequired && (isNaN(vi.value) || vi.value <= 0)) {
          vi.hasError = true;
          vi.error = vi.requiredError;
          return;
        }

        vi.hasError = false;
        vi.error = "";
      },
      emitChangeEvent: function () {
        this.$emit('change');
      }
    }
  }
</script>
